export default __webpack_public_path__ + "static/media/logout-icon-active.ec3d5491.svg";